import type { ReactNode } from "react";
import { Select, US_STATES } from "@dearbill/shared";
import { SectionHeading, type StepStatus } from "./SectionHeading";

export interface StateSectionProps {
  /** Selected US state code, or "" for none; the parent owns it. */
  state: string;
  onStateChange: (code: string) => void;
  /** Question 1's status; done once a state is selected. */
  status: StepStatus;
}

/**
 * Question 1, the patient's state (Figma dR8cJ6hRSW5eERToo64boe, node
 * 2340:165). The state narrows the plan search in question 2, and the
 * remembered value pre-selects it on repeat visits, so the plan combobox is
 * enabled from the first keystroke.
 */
export function StateSection({ state, onStateChange, status }: StateSectionProps): ReactNode {
  return (
    <section
      aria-labelledby="cost-tool-state-heading"
      className="border-border-strong rounded-2xl border bg-white p-6"
    >
      <SectionHeading id="cost-tool-state-heading" step={1} status={status}>
        Which state does the patient live in?
      </SectionHeading>
      {/* The question heading above is the visible label; a second visible
          "State" label would read as a duplicate (the Figma card shows only
          the question and the control). */}
      <div className="mt-3 sm:max-w-[14rem]">
        <Select
          label="State"
          labelHidden
          value={state}
          onChange={(e) => onStateChange(e.target.value)}
        >
          <option value="">Select state</option>
          {US_STATES.map((s) => (
            <option key={s.code} value={s.code}>
              {s.name}
            </option>
          ))}
        </Select>
      </div>
    </section>
  );
}
